const BrandingPanel = () => (
  <div className="hidden md:flex flex-col justify-between bg-black text-white w-2/5 p-10">
    <div>
      <div className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center mb-10">
        <div className="w-4 h-4 bg-white rounded-full" />
      </div>
      <h2 className="text-3xl font-bold leading-snug mt-4">
        Manage your<br />restaurant<br />with ease.
      </h2>
      <p className="text-gray-400 text-sm mt-4 leading-relaxed">
        Streamline orders, tables, and your team — all from one powerful dashboard.
      </p>
    </div>

    <div className="flex gap-2 mt-10">
      <span className="w-2 h-2 bg-white rounded-full opacity-80" />
      <span className="w-2 h-2 bg-white rounded-full opacity-40" />
      <span className="w-2 h-2 bg-white rounded-full opacity-40" />
    </div>

    <p className="text-gray-600 text-xs mt-6">
      © {new Date().getFullYear()} Kairalimenu
    </p>
  </div>
);

export default BrandingPanel;
